import { useState } from 'react'
import { Ic } from '../../../components/ui'
import { DK, fmt, fmtDateTime } from '../theme'
import { Card, PoolThumb, EmptyState } from '../components/DashboardUI'

export default function ProjectsTab({ projects, projectsLoading, onDelete, onDownloadPdf, pdfDownloadingId, resolveAssetUrl, projectNumberMap, navigate, c, goNewProject }) {
  const [confirm, setConfirm] = useState(null)

  if (projectsLoading) {
    return (
      <div className="wl-projects-grid">
        {[1,2,3,4,5,6].map(i => (
          <div key={i} style={{ height:268, borderRadius:16, background:c.bg2, animation:'wl-pulse 1.4s ease infinite' }}/>
        ))}
      </div>
    )
  }

  if (projects.length === 0) {
    return (
      <EmptyState
        title="Нет проектов"
        description="Создайте первый проект, чтобы он появился здесь. Это займёт всего несколько минут."
        action={goNewProject}
        actionLabel="+ Создать проект"
        c={c}
      />
    )
  }

  return (
    <>
      <div className="wl-projects-grid">
        {projects.map(p => {
          const num        = projectNumberMap.get(p.id) || p.id
          const previewUrl = resolveAssetUrl(p.previewUrl, p)
          return (
            <Card key={p.id} c={c} style={{ overflow:'hidden', transition:'transform .22s, box-shadow .22s, border-color .22s' }}
              onMouseEnter={e => {
                e.currentTarget.style.transform    = 'translateY(-3px) scale(1.005)'
                e.currentTarget.style.boxShadow    = '0 14px 40px rgba(15,163,177,.16)'
                e.currentTarget.style.borderColor  = 'rgba(31,200,214,.3)'
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform    = 'none'
                e.currentTarget.style.boxShadow    = 'none'
                e.currentTarget.style.borderColor  = c.line
              }}>

              {/* Thumbnail */}
              <div style={{ position:'relative' }}>
                <PoolThumb previewUrl={previewUrl} s={152}/>
                <span style={{
                  position:'absolute', top:10, left:10,
                  background:'rgba(1,8,16,.75)', backdropFilter:'blur(6px)',
                  color:'#1FC8D6', fontFamily:"'JetBrains Mono',monospace",
                  fontSize:11, fontWeight:700, padding:'3px 8px', borderRadius:6,
                  border:'1px solid rgba(31,200,214,.35)',
                }}>#{num}</span>
                <button onClick={e => { e.stopPropagation(); setConfirm(p.id) }} style={{
                  position:'absolute', top:8, right:8,
                  width:30, height:30, borderRadius:9,
                  background:'rgba(239,68,68,.15)', border:'1px solid rgba(239,68,68,.35)',
                  color:'#EF4444', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center',
                  transition:'all .18s', backdropFilter:'blur(4px)',
                }}
                onMouseEnter={e => { e.currentTarget.style.background = 'rgba(239,68,68,.35)'; e.currentTarget.style.borderColor = 'rgba(239,68,68,.65)' }}
                onMouseLeave={e => { e.currentTarget.style.background = 'rgba(239,68,68,.15)'; e.currentTarget.style.borderColor = 'rgba(239,68,68,.35)' }}>
                  <Ic n="trash" s={13}/>
                </button>
              </div>

              {/* Info */}
              <div style={{ padding:'14px 16px 16px' }}>
                <div style={{ fontSize:14, fontWeight:700, color:c.white, marginBottom:3, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                  {p.name || `Проект №${num}`}
                </div>
                <div style={{ fontSize:11.5, color:c.muted, marginBottom:p.serverTotalPrice ? 8 : 12, fontFamily:"'JetBrains Mono',monospace" }}>
                  {fmtDateTime(p.createdAt)}
                </div>
                {p.serverTotalPrice && (
                  <div style={{ fontSize:12, color:c.teal, fontWeight:600, marginBottom:12, fontFamily:"'JetBrains Mono',monospace" }}>
                    {fmt(p.serverTotalPrice)} ₸
                    {p.serverItemCount ? <span style={{ color:c.muted, fontWeight:400 }}> · {p.serverItemCount} позиций</span> : null}
                  </div>
                )}

                {/* Actions */}
                <div style={{ display:'flex', gap:8 }}>
                  <button onClick={() => navigate(`/app?projectId=${p.id}`)} style={{
                    flex:1, padding:'8px 0', borderRadius:9,
                    border:'1px solid rgba(15,163,177,.3)',
                    background:'linear-gradient(135deg,rgba(15,163,177,.12),rgba(10,123,134,.06))',
                    color:c.teal, fontSize:12.5, fontWeight:700, cursor:'pointer',
                    fontFamily:"'Plus Jakarta Sans','Manrope',sans-serif", transition:'all .18s',
                  }}
                  onMouseEnter={e => { e.currentTarget.style.background = 'rgba(15,163,177,.22)'; e.currentTarget.style.borderColor = 'rgba(15,163,177,.55)' }}
                  onMouseLeave={e => { e.currentTarget.style.background = 'linear-gradient(135deg,rgba(15,163,177,.12),rgba(10,123,134,.06))'; e.currentTarget.style.borderColor = 'rgba(15,163,177,.3)' }}>
                    Открыть 3D
                  </button>
                  <button onClick={() => onDownloadPdf(p.id)} disabled={pdfDownloadingId === p.id} style={{
                    flex:1, padding:'8px 0', borderRadius:9, border:`1px solid ${c.line}`,
                    background:'transparent', color:c.muted,
                    fontSize:12.5, fontWeight:600, cursor: pdfDownloadingId === p.id ? 'not-allowed' : 'pointer',
                    fontFamily:"'Plus Jakarta Sans','Manrope',sans-serif", transition:'all .18s',
                    opacity: pdfDownloadingId === p.id ? .5 : 1,
                  }}
                  onMouseEnter={e => { if (pdfDownloadingId !== p.id) { e.currentTarget.style.borderColor = c.teal; e.currentTarget.style.color = c.white } }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor = c.line; e.currentTarget.style.color = c.muted }}>
                    {pdfDownloadingId === p.id ? '↓ PDF...' : '↓ PDF'}
                  </button>
                </div>
              </div>
            </Card>
          )
        })}
      </div>

      {/* Delete confirm modal */}
      {confirm && (
        <div onClick={() => setConfirm(null)} style={{
          position:'fixed', inset:0, background:'rgba(0,0,0,.62)', backdropFilter:'blur(6px)',
          zIndex:200, display:'flex', alignItems:'center', justifyContent:'center', padding:24,
        }}>
          <div onClick={e => e.stopPropagation()} style={{
            background: c === DK ? 'linear-gradient(145deg,#040D18,#071422)' : c.card,
            border:`1px solid ${c.line}`, borderRadius:20, padding:28, maxWidth:380, width:'100%',
            boxShadow:'0 24px 60px rgba(0,0,0,.55)',
          }}>
            <div style={{ width:52, height:52, borderRadius:16, background:'rgba(239,68,68,.12)', border:'1px solid rgba(239,68,68,.25)', display:'flex', alignItems:'center', justifyContent:'center', color:'#EF4444', margin:'0 0 18px' }}>
              <Ic n="trash" s={24}/>
            </div>
            <h3 style={{ fontSize:16, fontWeight:800, color:c.white, marginBottom:8, letterSpacing:'-.015em' }}>Удалить проект?</h3>
            <p style={{ fontSize:13.5, color:c.muted, lineHeight:1.65, marginBottom:24 }}>
              Это действие необратимо. Проект и все связанные файлы будут удалены навсегда.
            </p>
            <div style={{ display:'flex', gap:10 }}>
              <button onClick={() => setConfirm(null)} style={{
                flex:1, padding:'10px 0', borderRadius:11, border:`1px solid ${c.line}`,
                background:'transparent', color:c.text, fontSize:14, fontWeight:600,
                cursor:'pointer', fontFamily:"'Plus Jakarta Sans','Manrope',sans-serif", transition:'all .18s',
              }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = c.teal; e.currentTarget.style.color = c.white }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = c.line; e.currentTarget.style.color = c.text }}>
                Отмена
              </button>
              <button onClick={() => { onDelete(confirm); setConfirm(null) }} style={{
                flex:1, padding:'10px 0', borderRadius:11, border:'none',
                background:'linear-gradient(135deg,#EF4444,#DC2626)', color:'#fff',
                fontSize:14, fontWeight:700, cursor:'pointer',
                fontFamily:"'Plus Jakarta Sans','Manrope',sans-serif",
                boxShadow:'0 4px 18px rgba(239,68,68,.38)',
              }}>
                Удалить навсегда
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
